module.exports = __webpack_public_path__ + "static/derro-f92a17ca17d514698a4aa3659e35be4d.png";